import script from "./AppRadioGroupNextOptionWithIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./AppRadioGroupNextOptionWithIcon.vue?vue&type=script&setup=true&lang=js"

import "./AppRadioGroupNextOptionWithIcon.vue?vue&type=style&index=0&id=80f0e6d2&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-80f0e6d2"]])

export default __exports__